import CodingCardField from "@/components/CodingCardField";
import ValueSetInputv2, {
  ValueSetMeta,
} from "@/components/controlled/ValueSetInput/ValueSetInputv2";
import TD, { TopDownFormProps } from "@/components/forms/TopDownForm";
import { CodeableConceptModel } from "@/data-models/value-models/structs";
import { IHumanReadableCoding } from "@/data-models/value-models/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { assert, boolean, string, type } from "superstruct";
import { IConceptObservationInputElement } from "./types";

type FieldValues = {
  quantity: IHumanReadableCoding | null;
  validCodedValueSet: string | null;
  inputType: IConceptObservationInputElement["inputType"] | null;
  hideLabel: boolean;
};

interface PropertiesFormProps
  extends Omit<TopDownFormProps<FieldValues>, "onSubmit"> {
  valueSet?: string;
  onSubmit?: (values: Partial<IConceptObservationInputElement>) => void;
}
const DEFAULT_VALUES =
  "http://tiro.health/fhir/ValueSet/snomed-ct-auto-generated";

function PropertiesForm({
  defaultValues,
  onSubmit,
  valueSet = DEFAULT_VALUES,
}: PropertiesFormProps) {
  const { t } = useTranslation();
  const handleSubmit = useCallback(
    (values: FieldValues) => {
      const { quantity } = values;
      const transformed = {
        ...values,
        code: {
          text: quantity?.display ?? "",
          coding: [quantity],
        },
      };
      assert(
        transformed,
        type({
          code: CodeableConceptModel,
          validCodedValueSet: string(),
          inputType: string(),
          hideLabel: boolean(),
        })
      );
      onSubmit && onSubmit(transformed);
    },
    [onSubmit]
  );

  return (
    <TD<FieldValues> onSubmit={handleSubmit} defaultValues={defaultValues}>
      {({ register, control }) => (
        <div>
          <fieldset className="block">
            <CodingCardField
              name="quantity"
              label="Code"
              valueSet={valueSet}
              control={control}
            />
            <TD.Option
              {...register("hideLabel")}
              label={t("hide-label")!}
              small
            />
          </fieldset>
          <fieldset className="mt-2 border-b border-gray-lighter pb-2">
            <div className="justify relative flex justify-between">
              <legend className="text-base font-medium text-gray-900">
                ValueSet
              </legend>
            </div>
            <ValueSetInputv2 name="validCodedValueSet">
              {({ query, onQueryChange, valueSet }) => {
                return (
                  <>
                    <ValueSetInputv2.Label className="sr-only">
                      Zoek ValueSet
                    </ValueSetInputv2.Label>
                    <ValueSetInputv2.Wrapper className="mt-1" query={query}>
                      <ValueSetInputv2.Input
                        autoComplete="off"
                        as={TD.Input}
                        small
                        onChange={(event) => onQueryChange(event.target.value)}
                        displayValue={(vs: ValueSetMeta | null) =>
                          vs?.title ?? ""
                        }
                      />
                    </ValueSetInputv2.Wrapper>
                    <ValueSetInputv2.VersionSelect
                      name="valueSetVersion"
                      url={valueSet?.url ?? ""}
                    />
                    {/**watch("inputType") == "dropdown" && (
                      <TD.Field
                        small
                        label="Placeholder"
                        {...register("placeholder", {
                          value: valueSet?.title,
                          deps: ["valueSet"],
                        })}
                      />
                      )**/}
                  </>
                );
              }}
            </ValueSetInputv2>
          </fieldset>
          <TD.Submit small>Update quantity</TD.Submit>
        </div>
      )}
    </TD>
  );
}

export default PropertiesForm;
